import axios from "axios";
import { Cookies } from "react-cookie";

import { StaticValue } from "../seed/constants";
import { clearClaimSession, getClaimToken } from "./companies/claimSession";

const staticValue = new StaticValue();
const staticValues = staticValue.getDefaultValues();

export const API = axios.create({
	baseURL: staticValues.apiUrl,
	headers: {
		"Content-Type": "application/json",
		...staticValues.commonHeader,
	},
});

const cookies = new Cookies();
API.interceptors.request.use((config) => {
	const authToken = cookies.get("Authorization");
	const claimToken = getClaimToken();

	if (authToken) {
		config.headers.Authorization = authToken;
	} else if (config.headers?.Authorization) {
		delete config.headers.Authorization;
	}

	if (config.authMode === "claim" && claimToken) {
		config.headers["x-claim-token"] = claimToken;
	} else if (config.headers?.["x-claim-token"]) {
		delete config.headers["x-claim-token"];
	}

	return config;
});

API.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		if ([401, 403].includes(error.response?.status)) {
			if (error.config?.authMode === "claim") {
				clearClaimSession();
				window.location.href = `/signin?ref=${encodeURIComponent(
					window.location.pathname + window.location.search + window.location.hash,
				)}`;
				return Promise.reject(error);
			}

			cookies.remove("Authorization");
			localStorage.removeItem("profileData");
			localStorage.removeItem("isDropzOpsUser");
			window.location.href = "/signin";
		}
		return Promise.reject(error);
	},
);
